import { motion } from "framer-motion";
import { Globe, Palette, Search, Megaphone, ArrowUpRight, Check } from "lucide-react";
import { SERVICES } from "@/data/content";

const ICONS = { web: Globe, brand: Palette, seo: Search, social: Megaphone };

const reveal = {
  hidden: { opacity: 0, y: 30 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.5, delay: i * 0.08 } }),
};

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="relative py-24 sm:py-32 border-t border-line">
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <span className="mono-label text-accent">[ What we do ]</span>
            <h2 className="font-head font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl mt-4 max-w-2xl text-balance">
              Everything your brand needs to win locally.
            </h2>
          </div>
          <p className="text-text-2 max-w-sm">
            One partner for design, development, marketing, and social — fully integrated,
            relentlessly focused on results.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-line border border-line">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.id];
            return (
              <motion.div
                key={s.id}
                custom={i}
                variants={reveal}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-80px" }}
                data-testid={`service-card-${s.id}`}
                className="group relative bg-surface p-8 lg:p-12 hover:bg-surface-2 transition-colors duration-300"
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="w-14 h-14 flex items-center justify-center border border-line group-hover:border-accent group-hover:text-accent transition-colors">
                    <Icon className="w-6 h-6" />
                  </div>
                  <span className="font-mono text-text-2 text-sm">{s.num}</span>
                </div>

                <h3 className="font-head font-bold text-2xl sm:text-3xl mb-3 group-hover:text-accent transition-colors">
                  {s.title}
                </h3>
                <p className="text-text-2 leading-relaxed mb-6 max-w-md">{s.blurb}</p>

                <ul className="flex flex-wrap gap-x-6 gap-y-2">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-center gap-2 text-sm text-white/80">
                      <Check className="w-3.5 h-3.5 text-accent" /> {p}
                    </li>
                  ))}
                </ul>

                <ArrowUpRight className="absolute top-8 right-8 w-6 h-6 text-line group-hover:text-accent opacity-0 group-hover:opacity-100 transition-all duration-300" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
